import type { QueryValue } from '../api/search';
import { trackLinkClick } from '../utils/trackLinkClick';
import * as style from './SearchType.module.css';

export interface SearchTypeInfo {
    pagination: { totalResults?: number };
    currentQuery: QueryValue;
}

interface SearchTypesProps {
    product: SearchTypeInfo | undefined;
    content: SearchTypeInfo | undefined;
    selected: 'product' | 'content';
    onSelect: (type: 'product' | 'content', query: string) => void;
}

export function SearchTypes({ product, content, selected, onSelect }: SearchTypesProps) {
    return selected === 'product' ? (
        <div className={style.searchType} onClick={trackLinkClick}>
            <span>Varer ({product?.pagination.totalResults ?? 0})</span>
            <button
                className="link"
                onClick={() => onSelect('content', content?.currentQuery.query.value ?? '')}
                data-count={content?.pagination.totalResults ?? 0}
            >
                Artikler ({content?.pagination.totalResults ?? 0})
            </button>
        </div>
    ) : (
        <div className={style.searchType} onClick={trackLinkClick}>
            <button
                className="link"
                onClick={() => onSelect('product', product?.currentQuery.query.value ?? '')}
                data-count={product?.pagination.totalResults ?? 0}
            >
                Varer ({product?.pagination.totalResults ?? 0})
            </button>
            <span>Artikler ({content?.pagination.totalResults ?? 0})</span>
        </div>
    );
}
